export default "__VITE_ASSET__DDduVhhJ__"